import { ScraperPage } from '@/features/scraper'
import { useAuth } from '@/context/AuthContext'
import { Navigate } from 'react-router-dom'

export default function SalesScraperPage() {
  const { user } = useAuth()
  const userDept = (user?.department || '').toLowerCase()
  const userRole = (user?.role || '').toLowerCase()
  if (userDept === 'accounts' || userDept === 'finance' || userRole === 'accounts') {
    return <Navigate to="/app" replace />
  }

  return <ScraperPage />
}